<template>
    <CModal
        title="Редактирование товара"
        :show.sync="modal.visible"
        :footer="false"
        class="order-gd-item-edit"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="pharmacies"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Аптека</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.pharmacy && modal.item.pharmacy.id">
                                <span class="order-gd-item-edit__title">{{ modal.item.pharmacy.title }}</span>
                            </template>
                            <template v-else>
                                <CSelect
                                    class="mb-0"
                                    inline
                                    :value="modal.item.pharmacy_id ? modal.item.pharmacy_id : null"
                                    :options="pharmacies"
                                    placeholder="Выберите аптеку..."
                                    @update:value="updatePharmacy"
                                />
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.pharmacy && modal.item.pharmacy.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Лекарство</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.drug && modal.item.drug.id">
                                <span class="order-gd-item-edit__title">{{ modal.item.drug.title }}</span>
                            </template>
                            <template v-else>
                                <Autocomplete
                                    ref="autocomplete"
                                    placeholder="Введите ID или часть названия"
                                    :search="getPharmacyDrug"
                                    :get-result-value="getResultValue"
                                    @submit="updateDrug"
                                />
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.drug_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.drug_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.drug_id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!modal.item.drug_id"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import '@trevoreyre/autocomplete-vue/dist/style.css';

    export default {
        name: 'OrderPDItemEdit',

        components: {
            Autocomplete,
        },

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                pharmacies: null,
                pharmacy: null,
                drugs: null,
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
        },

        watch: {
            visible: async function (val) {
                if(!this.pharmacies) {
                    try {
                        const { data } = await Vue.axios.get('/pharmacies');
                        data.sort((a, b) => a.title > b.title ? 1 : -1);
                        this.pharmacies = data.map(pharmacy => {
                            return {
                                value: pharmacy.id,
                                label: pharmacy.title
                            }
                        });
                    } catch(err) {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    }
                }
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            getResultValue(result) {
                return result.title;
            },
            async getPharmacyDrug(search) {
                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }

                    Vue.axios
                        .get(`/pharmacies/${ this.modal.item.pharmacy.id }/drugs?search=${ search }`, {})
                        .then(resp => {
                            resolve(resp.data.results);
                        })
                        .catch(err => {
                            console.log('Cannot load drug list.');
                        });
                });
            },
            async updatePharmacy(value) {
                this.pharmacy = this.pharmacies.filter(g => g.value == value).map(pharmacy => {
                    return {
                        id: pharmacy.value,
                        title: pharmacy.label
                    }
                })[0];
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                        id: this.modal.item.id,
                        pharmacy: this.pharmacy,
                        pharmacy_id: value
                    }
                };
                await this.getPharmacyDrug(this.modal.item.pharmacy_id);
            },
            async updateDrug(drug) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                        id: this.modal.item.id,
                        pharmacy: this.pharmacy,
                        pharmacy_id: this.modal.item.pharmacy_id,
                        drug: drug,
                        drug_id: drug.id,
                        title: drug.title,
                        price: drug.price
                    }
                };
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
        },
    };
</script>

<style lang="scss">
    .order-gd-item-edit {
        &__title {
            display: flex;
            align-items: center;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
        }
        .autocomplete-input {
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            border: 1px solid #d8dbe0;
            border-radius: 0.25rem;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-color: #fff;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 0.875rem;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .autocomplete-result {
            cursor: default;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 15px;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.1;
        }
    }
</style>
